import React from "react";
import "./style.scss";
export default ({ lists }) => {
  return (
    <main>
      <ol className="gradient-list">
        {lists?.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ol>
    </main>
  );
};
